import { Button as BaseButton, ButtonProps as BaseButtonProps } from 'antd'
import { ButtonGroup } from './button-group'

export interface ButtonProps extends BaseButtonProps {}

const Button = (props: ButtonProps): JSX.Element => (
  <>
    <BaseButton {...props} />
  </>
)

Button.Group = ButtonGroup

export default Button
